// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hVFa-","title":"styles_title__eiwXY","description":"styles_description__b1e2o","content":"styles_content__iGtUL"};